// function initPremiumGallery(scope = document) {
//   const stickyImage = scope.querySelector("#ppStickyImage");
//   if (stickyImage) {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (!entry.isIntersecting) return;
//         const img = entry.target.querySelector(".pp-gallery__thumb");
//         if (!img) return;
//         stickyImage.src = img.src;
//       });
//     }, {
//       threshold: 0.6
//     });

//     scope.querySelectorAll(".pp-gallery__right .pp-gallery__item").forEach(item => {
//       observer.observe(item);
//     });
//   }

//   scope.querySelectorAll(".pp-gallery-mobile").forEach(slider => {
//     if (slider.swiper) {
//       slider.swiper.destroy(true, true);
//     }
//     new Swiper(slider, {
//       loop: true,
//       autoplay: true,
//       slidesPerView: 1,
//       spaceBetween: 10,
//       grabCursor: true,
//       speed: 600,
//       pagination: {
//         el: slider.querySelector(".swiper-pagination"),
//         type: "fraction"
//       },
//       observer: true,
//       observeParents: true
//     });
//   });
  
// }

// document.addEventListener("DOMContentLoaded", () => {
//   initPremiumGallery(document);
// });

// window.initPremiumGallery = initPremiumGallery;

// // size chart js
// document.addEventListener("DOMContentLoaded", function () {
//     const openBtn = document.getElementById("OpenSizeChart");
//     const closeBtn = document.getElementById("CloseSizeChart");
//     const modal = document.getElementById("SizeChartModal");
//     if (!modal) return;
//     openBtn?.addEventListener("click", function () {
//         modal.classList.add("active");
//     });
//     closeBtn?.addEventListener("click", function () {
//         modal.classList.remove("active");
//     });
// });

function initPremiumGallery(scope = document) {
  // Prevent errors if Swiper isn't loaded yet
  if (typeof Swiper === "undefined") {
    console.warn("Swiper is not loaded yet.");
    return;
  }

  // Sticky image (Desktop)
  const stickyImage = scope.querySelector("#ppStickyImage");
  if (stickyImage) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const img = entry.target.querySelector(".pp-gallery__thumb");
          if (!img) return;

          stickyImage.src = img.src;
        });
      },
      {
        threshold: 0.6,
      }
    );

    scope
      .querySelectorAll(".pp-gallery__right .pp-gallery__item")
      .forEach((item) => observer.observe(item));
  }

  // Mobile Swiper
  scope.querySelectorAll(".pp-gallery-mobile").forEach((slider) => {
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      speed: 600,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "fraction",
      },

      observer: true,
      observeParents: true,
    });
  });
}

// Initial page load
document.addEventListener("DOMContentLoaded", () => {
  initPremiumGallery(document);
});

// Make globally available
window.initPremiumGallery = initPremiumGallery;

/* -------------------------
   Quick Add Modal Support
--------------------------*/

const observer = new MutationObserver(() => {
  document.querySelectorAll(".quick-add-modal__content").forEach((modal) => {
    if (!modal.dataset.galleryInitialized) {
      modal.dataset.galleryInitialized = "true";

      setTimeout(() => {
        window.initPremiumGallery(modal);
      }, 100);
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("click", function (e) {
  const openBtn = e.target.closest("#OpenSizeChart");
  const closeBtn = e.target.closest("#CloseSizeChart");
  const modal = document.getElementById("SizeChartModal");

  if (!modal) return;

  if (openBtn) {
    modal.classList.add("active");
  }

  if (closeBtn) {
    modal.classList.remove("active");
  }
});
